import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BaseComponent } from '../../../../components/BaseComponent';
import { CompanyProductSelection } from './companyProductSelection';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

class CompanyProductAddModalComp extends BaseComponent {
  get confirmDisabled() {
    return !this.props.companyId || !this.state.productId;
  }

  onCompleteCompanySelection(productId) {
    this.setState({ productId });
  }

  reset() {
    this.setState({ productId: null });
  }

  onConfirm() {
    this.props.onConfirm(this.props.companyId, this.state.productId);
  }

  onClose() {
    this.props.onClose();
  }

  render() {
    return (
      <ModalComponent onClose={this.onClose.bind(this)} title={this.lbl(`invoice.details.warning`)}>
        <CompanyProductSelection companyId={this.props.companyId} onComplete={this.onCompleteCompanySelection.bind(this)} />

        <div className="d-flex justify-content-end gap-2 mt-2">
          <ButtonComponent style="ButtonSoftEdit" disabled={this.confirmDisabled} onClick={this.onConfirm.bind(this)}>
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.onClose.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

CompanyProductAddModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductAddModal = compose(withConnect, withRouter)(CompanyProductAddModalComp);
